<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-alt"></i> Campanhas em Rede Social </h3>
        <small>Cadastro de Campanhas em Redes Sociais</small>
      </div>
    </div>
    <CampanhaRedeSocialAdd v-if="showAdd" ref="CampanhaRedeSocialAdd" v-on:Back="onBack" />
    <CampanhaRedeSocialList v-else ref="CampanhaRedeSocialList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import CampanhaRedeSocialAdd from './components/add/campanharedesocialadd.vue'
import CampanhaRedeSocialList from './components/list/campanharedesociallist.vue'

export default {
  name: 'CampaignTemplates',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    CampanhaRedeSocialAdd,
    CampanhaRedeSocialList
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.CampanhaRedeSocialAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/campaign/components/socialmedia/campanharedesocial.vue